import { useMediaQuery } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import { fetchEmployerTagline } from "../../../redux/actions/company_action";
import content_my from "./content_my.json";
import {
  GridStyledTagline,
  GridTagline,
  TaglineOverline,
  TaglineSubtitle,
  TaglineTitle,
} from "./styles";

export default function EmployerHeroTagline(props) {
  const [tagline, setTagline] = useState([]);
  const [scrollable, setScrollable] = useState(false);

  const belowLg = useMediaQuery("(max-width: 1279px)");
  const belowTablet = useMediaQuery("(max-width: 767px)");

  const dispatch = useDispatch();

  async function fetchData() {
    const responseApi = await dispatch(fetchEmployerTagline());

    const response = content_my;

    const { tagline } = response || {};

    setTagline(tagline);
  }

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <GridStyledTagline>
        {tagline?.slice(0, 1).map((tagline) => {
          return (
            <>
              <GridTagline sx={{ position: "sticky", top: "0px" }}>
                {tagline?.overline && (
                  <TaglineOverline>{tagline?.overline}</TaglineOverline>
                )}
                <TaglineTitle>{tagline?.mainTitle}</TaglineTitle>

                {tagline?.subTitle && (
                  <TaglineSubtitle>{tagline?.subTitle}</TaglineSubtitle>
                )}
              </GridTagline>
            </>
          );
        })}
      </GridStyledTagline>
    </>
  );
}
